import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button" }
const _hoisted_2 = { class: "button__label" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "scrollable-item-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "item-title" }

import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import ChannelIcon from '@/shared/icons/ChannelIcon.vue';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelIdentityPicker',
  props: {
  modelValue: {
    type: Object as PropType<ChannelIdentityViewModel>,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

const store = useStore();
const channelIdentities = computed<ChannelIdentityViewModel[]>(() => store.getters.channelIdentities);

onMounted(() => {
  if (!value.value && channelIdentities.value?.length > 0) {
    value.value = channelIdentities.value[0];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(DropDownMenu, {
    "drop-down-icon": "none",
    class: "is-flex-grow-1"
  }, {
    trigger: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _createVNode(ChannelIcon, {
          class: "button__label-icon",
          channelType: _unref(value).type
        }, null, 8, ["channelType"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(value).name), 1),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, { icon: "angle-up" })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelIdentities.value, (option) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: ($event: any) => (value.value = option),
            class: "dropdown-item",
            key: option.id
          }, [
            _createVNode(ChannelIcon, {
              class: "scrollable-item-list__icon",
              channelType: option.type
            }, null, 8, ["channelType"]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(option.name), 1)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})